<template>
  <!--리스트 갯수 기존과 동일-->
  <li class="phone_pro_list_li" @click="goItemView(item)">
    <!--나머지 영역 누르면 휴대폰 상세화면으로-->
    <div class="top">
      <div class="img_area">
        <img v-if="item.modelImage" :src="item.modelImage" alt="" />
      </div>
      <div class="txt_area">
        <h4>{{ item.modelName }}</h4>
        <p>{{ item.releaseDate }} 출시</p>
      </div>
      <div class="like_area">
        <div
          class="ic_like"
          :class="`${isBookmark === 'Y' ? 'on' : ''}`"
          @click.stop="toggleBookmark"
          v-if="!isMyPage"
        >
          <button></button>
        </div>
      </div>
    </div>
    <div class="btm">
      <div class="person_num">
        <p>
          <span>{{ item.viewCount }}</span
          >명이 선택!
        </p>
      </div>
      <button @click.stop="goMobile(item)">바로견적받기</button
      ><!--이부분 누르면 바로견적으로-->
    </div>
  </li>
</template>

<script>
import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';

import { toCurrency } from '@common/lib/common/utils.js';

export default {
  name: 'MobileProduct',
  description: '사용자 메인 - 휴대폰 스팩 찾기 ITEM',
  props: {
    item: Object,
    isMyPage: {
      type: Boolean,
      default: false,
    },
  },
  data(props) {
    return {
      isBookmark: props.item.isBookmark,
    };
  },
  methods: {
    ...mobileMapActions([mobileTypes.UPDATE_MOBILE_BOOKMARK]),
    goItemView(item) {
      this.$emit('view', item);
    },
    toggleBookmark() {
      if (this.isBookmark === 'Y') {
        this.isBookmark = 'N';
      } else {
        this.isBookmark = 'Y';
      }
      this.setBookmark();
    },
    setBookmark() {
      // let params = { ...this.item };
      let params = { modelId: this.item.modelId };
      params.procType = this.isBookmark === 'Y' ? 'ON' : 'OFF';
      this[mobileTypes.UPDATE_MOBILE_BOOKMARK](params);
      this.item.isBookmark = this.isBookmark;
    },
    formatNumber(val) {
      return toCurrency(val);
    },
    goMobile(item) {
      this.$emit('goMobile', item);
    },
  },
};
</script>
